import React from 'react';
import cx from 'classnames';

// components
import { CodeSnippet } from 'src/components/Surfaces';
import { Link } from 'src/components/Inputs';
import ArrowRightSingleSmall from 'src/components/SVGs/Icons/ArrowRightSingleSmall';
import Image from 'src/components/Image';

const DescriptionRowCode = (props) => {
  return (
    <>
      <div className='show-for-medium'>
        <div className='grid-x grid-container description-row-code'>
          <div className='small-12 medium-7 cell'>
            <h6 className='section-title'> </h6>
            <h4 className='section-header'>{props['title']}</h4>
            <p className='content-carousel-description'>{props['body']}</p>
            <Link href={props['cta-url']}>
              <a>
                <span className='feature-section-link-text'>
                  {props['cta-text']} <ArrowRightSingleSmall />
                </span>
              </a>
            </Link>
          </div>
          <div className='small-12 medium-5 cell description-row-code-wrapper'>
            <div className='description-row-code-accent-0'>
              <Image alt='brushstroke' src={props['stroke']} />
            </div>
            <div className='description-row-code-block'>
              <CodeSnippet
                syntax={props['code-lang']}
                children={props['code-body']}
              />
            </div>
          </div>
        </div>
      </div>
      <div className='show-for-small-only'>
        <div
          className={cx(
            'grid-container',
            'carousel-mobile',
            'homepage-mobile',
            'full',
            { 'carousel-mobile--margin-bottom': props['mobile-margin-bottom'] },
          )}
        >
          {/*// Content Container 0*/}
          <div className='grid-x grid-margin-x grid-padding-x'>
            <div className='small-12 cell'>
              <div className='carousel-mobile-content'>
                <span id='hContent0' className='carousel-content animated'>
                  {Boolean(props['section-title']) && (
                    <h6 className='section-title how-title'>
                      {props['section-title']}
                    </h6>
                  )}
                  <h4 className='carousel-content-title'>{props['title']}</h4>
                  <p>{props['body']}</p>
                  <Link href={props['cta-url']}>
                    <a>
                      <span className='feature-section-link-text'>
                        {props['cta-text']}
                        <ArrowRightSingleSmall />
                      </span>
                    </a>
                  </Link>
                </span>
              </div>
            </div>
          </div>

          {/*//Media Container 0*/}
          <div className='code'>
            <div className='grid-x'>
              <div className='small-12 cell'>
                <div className='horizontal-code'>
                  <CodeSnippet syntax='html' children={props['code-body']} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DescriptionRowCode;
